import { React } from "react";
import "./footer.css";
import { MdEmail } from "react-icons/md";

export default function Footer() {
    return (
        <div className="footer">
            <div className="footerTop">
                <div className="footerTopLeft">
                    <p>I am a full stack doveloper from india,studying Btech in chittor</p>
                </div>
                <div className="footerTopRight">
                    <div className="footerEmailInput">
                        <MdEmail/>
                        <input type="email" placeholder="enter your email" />
                    </div>
                    <div className="footerSubscribe">Subscribe</div>
                </div>
            </div>
            <hr />
            <div className="footerBottom">
                <p className="footrBottomLeft">@ 2024 Roshan Sameer.All rights reserved.</p>
                <div className="footerBottomRight">
                    <p>Term of services</p>
                    <p>Privicy policy</p>
                    <p>Connect With Me</p>
                </div>
            </div>
        </div>
    )
}